import * as React from 'react'
import styled, { keyframes } from '../styles/styled-components'

const Container = styled.main`
  margin: 60px 0;
  width: 100%;
`
const loader1 = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`
const loader2 = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`
const loader3 = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`
const Loader = styled.div<{ size: number }>`
  display: block;
  height: ${p => p.size}px;
  width: ${p => p.size}px;
  margin: 0 auto;
  animation: ${loader1} 3s linear infinite;

  span {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    height: ${p => p.size}px;
    width: ${p => p.size}px;
    clip: rect(16px, ${p => p.size}px, ${p => p.size}px, 0);
    animation: ${loader2} 1.5s cubic-bezier(0.77, 0, 0.175, 1) infinite;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: ${p => p.size}px;
      width: ${p => p.size}px;
      border: 3px solid transparent;
      border-top: 3px solid ${p => p.theme.colors.brand};
      border-radius: 50%;
      animation: ${loader3} 1.5s cubic-bezier(0.77, 0, 0.175, 1) infinite;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: ${p => p.size}px;
      width: ${p => p.size}px;
      border: 3px solid rgba(255, 255, 255, 0.5);
      border-radius: 50%;
    }
  }
`

export const Spinner: React.SFC<{ size: number, className?: string }> = ({ size, className }) => (
  <Container className={className}>
    <Loader size={size}>
      <span />
    </Loader>
  </Container>
)

Spinner.defaultProps = { size: 64 }



// WEBPACK FOOTER //
// ./src/components/Spinner.tsx